/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import BaseService from '../../../services/BaseService';
import { ChartCard, itemsHaveMediaDiaUtil } from './chartShared';
import ChartFocusDialog from './ChartFocusDialog';
import DigitadorCargaChart from './DigitadorCargaChart';
import ProdutividadeChart from './ProdutividadeChart';

const FOCUS_HEIGHT = 520;

const ChartsRow = ({ apiFilterBase, refreshKey }) => {
  const [prodItems, setProdItems] = useState([]);
  const [prodLoading, setProdLoading] = useState(false);
  const [cargaItems, setCargaItems] = useState([]);
  const [cargaLoading, setCargaLoading] = useState(false);
  const [focusProd, setFocusProd] = useState(false);
  const [focusCarga, setFocusCarga] = useState(false);

  const fetchProd = useCallback(async () => {
    setProdLoading(true);
    try {
      const response = await BaseService.post({
        url: 'reports/digitacao/charts/by-digitador',
        data: apiFilterBase,
      });
      setProdItems(response?.data?.items || []);
    } catch {
      setProdItems([]);
    } finally {
      setProdLoading(false);
    }
  }, [apiFilterBase, refreshKey]);

  const fetchCarga = useCallback(async () => {
    setCargaLoading(true);
    try {
      const response = await BaseService.post({
        url: 'reports/digitacao/charts/by-digitador-carga',
        data: apiFilterBase,
      });
      setCargaItems(response?.data?.items || []);
    } catch {
      setCargaItems([]);
    } finally {
      setCargaLoading(false);
    }
  }, [apiFilterBase, refreshKey]);

  useEffect(() => {
    fetchProd();
  }, [fetchProd]);

  useEffect(() => {
    fetchCarga();
  }, [fetchCarga]);

  const prodTitle = useMemo(
    () =>
      itemsHaveMediaDiaUtil(prodItems)
        ? 'Produtividade por digitador (média/dia útil)'
        : 'Produtividade por digitador',
    [prodItems],
  );

  const cargaTitle = 'Carga por digitador';

  return (
    <>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, lg: 6 }}>
          <ChartCard
            title={prodTitle}
            onExpand={() => setFocusProd(true)}
            contentSx={{ pl: 1, pr: 2 }}
          >
            <ProdutividadeChart items={prodItems} loading={prodLoading} />
          </ChartCard>
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <ChartCard
            title={cargaTitle}
            onExpand={() => setFocusCarga(true)}
            contentSx={{ pl: 1, pr: 2 }}
          >
            <DigitadorCargaChart items={cargaItems} loading={cargaLoading} />
          </ChartCard>
        </Grid>
      </Grid>

      <ChartFocusDialog open={focusProd} title={prodTitle} onClose={() => setFocusProd(false)}>
        <ProdutividadeChart items={prodItems} loading={prodLoading} height={FOCUS_HEIGHT} />
      </ChartFocusDialog>

      <ChartFocusDialog open={focusCarga} title={cargaTitle} onClose={() => setFocusCarga(false)}>
        <DigitadorCargaChart items={cargaItems} loading={cargaLoading} height={FOCUS_HEIGHT} />
      </ChartFocusDialog>
    </>
  );
};

ChartsRow.propTypes = {
  apiFilterBase: PropTypes.object.isRequired,
  refreshKey: PropTypes.bool,
};

ChartsRow.defaultProps = {
  refreshKey: false,
};

export default ChartsRow;
